/**
 * Reads the provided File and returns its contents as a Base64-encoded string (without the data prefix).
 *
 * @param file - The file to be read and encoded.
 * @returns A promise that resolves with the Base64-encoded string of the file's contents.
 *
 * The function uses FileReader's readAsDataURL to get a "data:* / *;base64,..." URL,
 * then extracts and returns only the Base64 part after the comma.
 */
export const readFileAsBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result as string;
      const base64Data = base64.split(',')[1];
      resolve(base64Data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};
